<template>
  <header>
    <div class="h-inner">
      <div class="logo">
        <img
          :src="logoUrl"
          alt="ISBET"
          style="height:100px;object-fit:contain;"
        />
        <div class="logo-text">
          <div class="logo-sub">Wootdash</div>
        </div>
      </div>
      <div class="h-right">
        <div class="live-badge">
          <div class="live-dot"></div>
          Ao vivo
        </div>
        <!-- Botão teste de notificação — visível só com tecla & -->
        <button v-show="showTestBtn" class="btn-notif-test" @click="$emit('testNotif')" title="Testar notificação (& para esconder)">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
            <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
          </svg>
          <span>Testar Notif.</span>
        </button>

        <!-- Botão teste do aviso de inatividade — visível só com Ctrl+Shift+* -->
        <button
          v-show="showAutoLogoutTestBtn"
          class="btn-notif-test"
          @click.stop="triggerTestWarning"
          :title="`Testar aviso de inatividade (Ctrl+Shift+* para esconder) — ${autoLogoutCountdownLabel}`"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="10"/>
            <polyline points="12 6 12 12 16 14"/>
          </svg>
          <span>Testar Inatividade</span>
          <span class="btn-refresh-count">{{ autoLogoutCountdownLabel }}</span>
        </button>
        <button class="btn-export" @click="$emit('export')">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
          <span>Exportar</span>
        </button>

        <div class="docs-wrap" ref="docsWrap">
          <button class="btn-docs" @click.stop="showDocsMenu = !showDocsMenu" title="Abrir documentação">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
              <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
            </svg>
            <span>Docs</span>
            <svg width="10" height="10" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="opacity:.7"><polyline points="6 9 12 15 18 9"/></svg>
          </button>
          <Transition name="avail-menu">
            <div v-if="showDocsMenu" class="docs-menu">
              <button class="docs-opt" @click="openDoc('dashboard-documentacao.html')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M2 3h6a4 4 0 0 1 4 4v14a3 3 0 0 0-3-3H2z"/>
                  <path d="M22 3h-6a4 4 0 0 0-4 4v14a3 3 0 0 1 3-3h7z"/>
                </svg>
                Documentação
              </button>
              <button class="docs-opt" @click="openDoc('guia-do-usuario.html')">
                <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <circle cx="12" cy="12" r="10"/>
                  <path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 2-3 4"/>
                  <line x1="12" y1="17" x2="12.01" y2="17"/>
                </svg>
                Guia do Usuário
              </button>
            </div>
          </Transition>
        </div>

        <!-- Botão tema claro/escuro -->
        <button class="btn-theme" :title="darkMode ? 'Mudar para tema claro' : 'Mudar para tema escuro'" @click="toggleTheme">
          <!-- Sol (tema claro ativo → clique vai para escuro) -->
          <svg v-if="!darkMode" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <circle cx="12" cy="12" r="5"/>
            <line x1="12" y1="1" x2="12" y2="3"/>
            <line x1="12" y1="21" x2="12" y2="23"/>
            <line x1="4.22" y1="4.22" x2="5.64" y2="5.64"/>
            <line x1="18.36" y1="18.36" x2="19.78" y2="19.78"/>
            <line x1="1" y1="12" x2="3" y2="12"/>
            <line x1="21" y1="12" x2="23" y2="12"/>
            <line x1="4.22" y1="19.78" x2="5.64" y2="18.36"/>
            <line x1="18.36" y1="5.64" x2="19.78" y2="4.22"/>
          </svg>
          <!-- Lua (tema escuro ativo → clique vai para claro) -->
          <svg v-else viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 12.79A9 9 0 1 1 11.21 3 7 7 0 0 0 21 12.79z"/>
          </svg>
        </button>

        <!-- Meu Time filter toggle -->
        <button
          v-if="!isEcIsbet"
          class="btn-myteam"
          :class="{ active: myTeamFilter }"
          title="Filtrar minhas conversas"
          @click="$emit('toggleMyTeamFilter')"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/>
          </svg>
          <span>Meu Time</span>
          <span v-if="myCount > 0" class="btn-myteam-badge">{{ myCount }}</span>
        </button>

        <!-- Meus Fluxos filter toggle — perfil EC - ISBET só vê os fluxos que atende como fallback -->
        <button
          v-else
          class="btn-myteam"
          :class="{ active: myFluxosFilter }"
          title="Filtrar conversas só dos meus fluxos"
          @click="$emit('toggleMyFluxosFilter')"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="22 12 18 12 15 21 9 3 6 12 2 12"/>
          </svg>
          <span>Meus Fluxos</span>
        </button>

        <!-- Esconder Fluxo — some das KPIs/grid/abas do Dashboard e de Minhas Conversas/faixa de avatares -->
        <div v-if="canHideFluxo" class="hf-wrap">
          <MultiSelectFilter :options="fluxoHideOptions" v-model="hiddenFluxoModel" placeholder="Esconder Fluxo" />
        </div>

        <button
          class="btn-refresh"
          :class="{ spinning: loading }"
          :title="`Auto-atualização em ${countdown}s`"
          @click="hardRefresh"
        >
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
            <polyline points="23 4 23 10 17 10"/>
            <polyline points="1 20 1 14 7 14"/>
            <path d="M3.51 9a9 9 0 0 1 14.85-3.36L23 10M1 14l4.64 4.36A9 9 0 0 0 20.49 15"/>
          </svg>
          <span>Atualizar</span>
          <span class="btn-refresh-count" v-if="!loading">{{ countdown }}s</span>
        </button>

        <!-- Usuário logado -->
        <div class="h-user" v-if="user">
          <router-link to="/profile" class="h-user-link" title="Meu perfil">
            <div class="h-user-avatar">
              <img
                v-if="user.avatar_url"
                :src="user.avatar_url"
                :alt="user.name"
                class="h-avatar-img"
                @error="avatarError = true"
                v-show="!avatarError"
              />
              <span
                class="h-avatar-initials"
                :class="{ hidden: user.avatar_url && !avatarError }"
              >{{ initials }}</span>
              <!-- bolinha de status no canto do avatar -->
              <span class="h-avail-badge" :class="`h-avail-badge--${availStatus}`"></span>
            </div>
            <div class="h-user-info">
              <span class="h-user-name">{{ user.name }}</span>
              <span class="h-user-role">{{ roleLabel }}</span>
              <span v-if="myOpenCount > 0" class="h-atend-badge">
                <svg width="9" height="9" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                  <path d="M3 18v-6a9 9 0 0 1 18 0v6"/>
                  <path d="M21 19a2 2 0 0 1-2 2h-1a2 2 0 0 1-2-2v-3a2 2 0 0 1 2-2h3zM3 19a2 2 0 0 0 2 2h1a2 2 0 0 0 2-2v-3a2 2 0 0 0-2-2H3z"/>
                </svg>
                em atendimento
              </span>
            </div>
          </router-link>

          <!-- Seletor de disponibilidade -->
          <div class="h-avail-wrap" ref="availWrap">
            <button class="h-avail-trigger" :class="`h-avail-trigger--${availStatus}`" @click.stop="showAvailMenu = !showAvailMenu" :title="`Disponibilidade: ${availLabelHeader}`">
              <span class="h-avail-dot"></span>
              <svg width="8" height="8" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" style="opacity:.7"><polyline points="6 9 12 15 18 9"/></svg>
            </button>
            <Transition name="avail-menu">
              <div v-if="showAvailMenu" class="h-avail-menu">
                <button
                  v-for="opt in AVAIL_OPTIONS" :key="opt.value"
                  class="h-avail-opt"
                  :class="{ 'h-avail-opt--active': availStatus === opt.value }"
                  @click="changeAvail(opt.value)"
                  :disabled="changingAvail"
                >
                  <span class="h-avail-opt-dot" :style="{ background: opt.color }"></span>
                  {{ opt.label }}
                </button>
              </div>
            </Transition>
          </div>

          <!-- Feedback de disponibilidade -->
          <Transition name="avail-err">
            <div v-if="availError" class="h-avail-error">{{ availError }}</div>
          </Transition>
          <Transition name="avail-err">
            <div v-if="availSuccess" class="h-avail-success">{{ availSuccess }}</div>
          </Transition>

          <button class="btn-logout" @click="$emit('logout')" title="Sair">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
          </button>
        </div>
      </div>
    </div>
  </header>
  <div class="topbar">
    <div class="topbar-inner">
      <span>Wootdash <strong>CRM</strong> — Conversas em tempo real</span>
      <span>Atualizado: <strong>{{ lastUpdate || '—' }}</strong></span>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue'
import type { AuthUser } from '@/types/auth'
import { useTheme } from '@/composables/useTheme'
import { useAdmin } from '@/composables/useAdmin'
import { usePermission } from '@/composables/usePermission'
import { availStatus, updateAvailability, AVAIL_OPTIONS, syncAvailStatus } from '@/composables/useAvailability'
import { useLogo } from '@/composables/useLogo'
import { secondsUntilWarning, showWarning, triggerTestWarning } from '@/composables/useAutoLogout'
import { hiddenFluxoIds, setHiddenFluxoIds } from '@/composables/useHiddenFluxos'
import { FLUXO_MAP } from '@/composables/useHelpers'
import { roleFilteredConversations } from '@/composables/useDashboardEngine'
import MultiSelectFilter from '@/components/dashboard/MultiSelectFilter.vue'

const { logoUrl } = useLogo()

const props = defineProps<{
  loading:       boolean
  lastUpdate:    string
  countdown:     number
  user:          AuthUser | null
  myCount:        number
  myOpenCount:    number
  myTeamFilter:   boolean
  myFluxosFilter: boolean
}>()

defineEmits<{
  export:              []
  logout:              []
  testNotif:           []
  toggleMyTeamFilter:   []
  toggleMyFluxosFilter: []
}>()

// Botão "Atualizar": força reload equivalente a Ctrl+F5 (limpa cache do SW e
// do browser antes de recarregar), em vez de só re-buscar dados via API.
async function hardRefresh() {
  try {
    if ('serviceWorker' in navigator) {
      const regs = await navigator.serviceWorker.getRegistrations()
      await Promise.all(regs.map(r => r.unregister()))
    }
    if ('caches' in window) {
      const keys = await caches.keys()
      await Promise.all(keys.map(k => caches.delete(k)))
    }
  } finally {
    window.location.reload()
  }
}

const { darkMode, toggleTheme } = useTheme()
const { profiles } = useAdmin()
const { can } = usePermission()
const canHideFluxo = computed(() => can('dashboard.hideFluxo'))
const fluxoHideOptions = computed(() => Object.entries(FLUXO_MAP).map(([id, name]) => ({
  id:    Number(id),
  name,
  count: roleFilteredConversations.value.filter(c => c.fluxo_id === Number(id)).length,
})))
const hiddenFluxoModel = computed({
  get: () => hiddenFluxoIds.value,
  set: (v: Array<number | string>) => setHiddenFluxoIds(v.map(Number)),
})
const avatarError    = ref(false)
const showTestBtn    = ref(false)
const showAutoLogoutTestBtn = ref(false)
const showAvailMenu  = ref(false)
const changingAvail  = ref(false)
const availWrap      = ref<HTMLElement | null>(null)
const availError     = ref('')
const availSuccess   = ref('')
const showDocsMenu   = ref(false)
const docsWrap       = ref<HTMLElement | null>(null)

const availLabelHeader = computed(() => {
  const map: Record<string, string> = { online: 'Online', busy: 'Ocupado', offline: 'Offline' }
  return map[availStatus.value] ?? availStatus.value
})

async function changeAvail(status: string) {
  if (!props.user?.access_token) {
    availError.value = 'Sem token de acesso'
    setTimeout(() => { availError.value = '' }, 5000)
    return
  }
  showAvailMenu.value = false
  changingAvail.value = true
  availError.value   = ''
  availSuccess.value = ''
  try {
    await updateAvailability(props.user.access_token, status as any, props.user.id)
    availSuccess.value = 'Status atualizado!'
    setTimeout(() => { availSuccess.value = '' }, 3000)
  } catch (e: any) {
    console.error('[DashHeader] Erro ao atualizar disponibilidade:', e)
    availError.value = e?.message || 'Erro ao atualizar'
    setTimeout(() => { availError.value = '' }, 8000)
  }
  changingAvail.value = false
}

function onDocClick(e: MouseEvent) {
  if (availWrap.value && !availWrap.value.contains(e.target as Node)) {
    showAvailMenu.value = false
  }
  if (docsWrap.value && !docsWrap.value.contains(e.target as Node)) {
    showDocsMenu.value = false
  }
}

function openDoc(file: string) {
  window.open(`/docs/${file}`, '_blank')
  showDocsMenu.value = false
}

function onKeyDown(e: KeyboardEvent) {
  // Ignora se o foco estiver em input/textarea
  const tag = (e.target as HTMLElement)?.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA') return
  if (e.key === '&') showTestBtn.value = !showTestBtn.value
  if (e.ctrlKey && e.key === '*') {
    e.preventDefault()
    showAutoLogoutTestBtn.value = !showAutoLogoutTestBtn.value
  }
}

// "Ativo!" enquanto o modal/toast já está em tela; senão mm:ss até disparar
// sozinho (null = auto-logout desativado ou rota isenta — sem contagem).
const autoLogoutCountdownLabel = computed(() => {
  if (showWarning.value) return 'Ativo!'
  if (secondsUntilWarning.value === null) return 'desativado'
  const total = secondsUntilWarning.value
  const mm = Math.floor(total / 60)
  const ss = total % 60
  return `${mm}:${String(ss).padStart(2, '0')}`
})

onMounted(async () => {
  document.addEventListener('keydown', onKeyDown)
  document.addEventListener('click', onDocClick)
  // Sincroniza disponibilidade real do usuário logado (limpa localStorage de sessão anterior)
  if (props.user?.access_token) {
    try {
      const res = await fetch('/chatwoot-api/api/v1/profile', {
        headers: { api_access_token: props.user.access_token },
      })
      if (res.ok) {
        const profile = await res.json()
        const account = profile.accounts?.find((a: any) => a.id === 3)
        // Prefere `availability` (o que o próprio agente define no dropdown) sobre
        // `availability_status` (presença computada pelo Chatwoot via ActionCable/
        // auto_offline, que fica "offline" pra quem só acessa via esta dashboard).
        const status = account?.availability || account?.availability_status || profile.availability_status || 'offline'
        syncAvailStatus(status)
      }
    } catch { /* silent */ }
  }
})
onUnmounted(() => {
  document.removeEventListener('keydown', onKeyDown)
  document.removeEventListener('click', onDocClick)
})

const initials = computed(() => {
  if (!props.user?.name) return ''
  return props.user.name
    .split(' ')
    .slice(0, 2)
    .map(w => w[0])
    .join('')
    .toUpperCase()
})

const currentProfile = computed(() => {
  if (!props.user) return null
  return profiles.value.find(p => p.userIds.includes(props.user!.id)) ?? null
})

const roleLabel = computed(() => {
  if (!props.user) return ''
  if (currentProfile.value) return currentProfile.value.name
  return props.user.role === 'administrator' ? 'Administrador' : 'Agente'
})

// Perfil "EC - ISBET" (fallback) não tem time próprio no Chatwoot — troca o
// filtro "Meu Time" por "Meus Fluxos" (ver DashboardView.vue → myFluxosFilter).
const isEcIsbet = computed(() => currentProfile.value?.name === 'EC - ISBET')
</script>

<style scoped>
.h-user {
  display: flex;
  align-items: center;
  gap: 10px;
  background: rgba(255,255,255,0.07);
  border: 1px solid rgba(255,255,255,0.12);
  border-radius: 40px;
  padding: 4px 14px 4px 4px;
}

.h-user-link {
  display: flex;
  align-items: center;
  gap: 10px;
  text-decoration: none;
  border-radius: 36px;
  padding: 2px 4px;
  transition: background var(--ease);
  cursor: pointer;
}
.h-user-link:hover {
  background: rgba(255,255,255,0.08);
}

.h-user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  overflow: hidden;
  background: var(--red-dark);
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.h-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 50%;
}

.h-avatar-initials {
  font-size: 11px;
  font-weight: 700;
  color: #fff;
  letter-spacing: 0.3px;
}

.h-avatar-initials.hidden { display: none; }

.h-user-info {
  display: flex;
  flex-direction: column;
  line-height: 1.2;
}

.h-user-name {
  font-size: 12.5px;
  font-weight: 600;
  color: #fff;
  white-space: nowrap;
  max-width: 120px;
  overflow: hidden;
  text-overflow: ellipsis;
}

.h-user-role {
  font-size: 9.5px;
  color: rgba(255,255,255,0.4);
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.6px;
}

.btn-logout {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 28px;
  height: 28px;
  background: rgba(255,255,255,0.08);
  border: none;
  border-radius: 50%;
  color: rgba(255,255,255,0.55);
  cursor: pointer;
  transition: background var(--ease), color var(--ease);
  flex-shrink: 0;
  margin-left: 2px;
}

.btn-logout:hover {
  background: rgba(220,60,60,0.3);
  color: #fff;
}

@media (max-width: 768px) {
  .h-user-info { display: none; }
  .h-user { padding: 4px; }
}

.docs-wrap { position: relative; }

.btn-docs {
  display: flex; align-items: center; gap: 7px;
  background: rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.75);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: var(--r-sm);
  padding: 8px 14px;
  font-size: 12.5px; font-weight: 600; font-family: inherit;
  cursor: pointer;
  transition: background var(--ease), color var(--ease);
}
.btn-docs:hover { background: rgba(255,255,255,0.15); color: #fff; }

.docs-menu {
  position: absolute; top: calc(100% + 6px); left: 0;
  background: #1e2130; border: 1px solid rgba(255,255,255,0.12);
  border-radius: 10px; padding: 6px; min-width: 175px;
  box-shadow: 0 8px 24px rgba(0,0,0,.35);
  z-index: 9999;
  display: flex; flex-direction: column; gap: 2px;
}
.docs-opt {
  display: flex; align-items: center; gap: 8px;
  padding: 7px 10px; border-radius: 7px;
  font-size: 12.5px; font-weight: 500; color: rgba(255,255,255,0.75);
  background: none; border: none; cursor: pointer; width: 100%; text-align: left;
  font-family: inherit; transition: background 0.15s;
}
.docs-opt:hover { background: rgba(255,255,255,0.08); color: #fff; }
.docs-opt svg { flex-shrink: 0; opacity: .8; }

.btn-myteam {
  position: relative;
  display: flex; align-items: center; gap: 7px;
  background: rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.75);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: var(--r-sm);
  padding: 8px 14px;
  font-size: 12.5px; font-weight: 600; font-family: inherit;
  cursor: pointer;
  transition: background var(--ease), color var(--ease), border-color var(--ease);
}
.btn-myteam:hover { background: rgba(255,255,255,0.15); color: #fff; }
.btn-myteam.active { background: rgba(255,255,255,0.22); color: #fff; border-color: rgba(255,255,255,0.5); }
.btn-myteam-badge {
  background: var(--red);
  color: #fff;
  font-size: 10px; font-weight: 700;
  padding: 1px 5px;
  border-radius: 20px;
  line-height: 1.4;
}

/* Esconder Fluxo — reaproveita MultiSelectFilter.vue (dropdown genérico,
   classes globais em dashboard.css), só reestiliza o botão-gatilho pra
   combinar com os outros botões do header escuro (mesmo visual do .btn-myteam). */
.hf-wrap { flex-shrink: 0; }
.hf-wrap :deep(.flt-dropdown-btn) {
  background: rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.75);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: var(--r-sm);
  padding: 8px 14px;
  font-size: 12.5px;
  min-width: 0;
}
.hf-wrap :deep(.flt-dropdown-btn:hover) { background: rgba(255,255,255,0.15); color: #fff; }
.hf-wrap :deep(.flt-dropdown-btn.open),
.hf-wrap :deep(.flt-dropdown-btn.selected) {
  background: rgba(255,255,255,0.22); color: #fff; border-color: rgba(255,255,255,0.5);
}

.btn-notif-test {
  display: flex; align-items: center; gap: 7px;
  background: rgba(255,255,255,0.08);
  color: rgba(255,255,255,0.75);
  border: 1px solid rgba(255,255,255,0.18);
  border-radius: var(--r-sm);
  padding: 8px 14px;
  font-size: 12.5px; font-weight: 600; font-family: inherit;
  cursor: pointer;
  transition: background var(--ease), color var(--ease);
}
.btn-notif-test:hover { background: rgba(255,255,255,0.15); color: #fff; }

/* ── Disponibilidade no header ── */
.h-avail-badge {
  position: absolute; bottom: 0; right: 0;
  width: 10px; height: 10px; border-radius: 50%;
  background: #9ca3af;
  border: 2px solid var(--red-dark, #7a0016);
  flex-shrink: 0;
}
.h-avail-badge--online  { background: #22c55e; }
.h-avail-badge--busy    { background: #f59e0b; }
.h-avail-badge--offline { background: #9ca3af; }

.h-avail-wrap {
  position: relative;
}
.h-avail-trigger {
  display: flex; align-items: center; gap: 4px;
  background: rgba(255,255,255,0.08);
  border: 1px solid rgba(255,255,255,0.15);
  border-radius: 20px;
  padding: 5px 8px;
  cursor: pointer;
  transition: background var(--ease);
}
.h-avail-trigger:hover { background: rgba(255,255,255,0.15); }

.h-avail-dot {
  width: 8px; height: 8px; border-radius: 50%; background: #9ca3af; flex-shrink: 0;
}
.h-avail-trigger--online  .h-avail-dot { background: #22c55e; }
.h-avail-trigger--busy    .h-avail-dot { background: #f59e0b; }
.h-avail-trigger--offline .h-avail-dot { background: #9ca3af; }

.h-avail-menu {
  position: absolute; top: calc(100% + 6px); right: 0;
  background: #1e2130; border: 1px solid rgba(255,255,255,0.12);
  border-radius: 10px; padding: 6px; min-width: 130px;
  box-shadow: 0 8px 24px rgba(0,0,0,.35);
  z-index: 9999;
  display: flex; flex-direction: column; gap: 2px;
}
.h-avail-opt {
  display: flex; align-items: center; gap: 8px;
  padding: 7px 10px; border-radius: 7px;
  font-size: 12.5px; font-weight: 500; color: rgba(255,255,255,0.75);
  background: none; border: none; cursor: pointer; width: 100%; text-align: left;
  font-family: inherit; transition: background 0.15s;
}
.h-avail-opt:hover:not(:disabled) { background: rgba(255,255,255,0.08); color: #fff; }
.h-avail-opt--active { color: #fff; font-weight: 600; }
.h-avail-opt:disabled { opacity: 0.4; cursor: not-allowed; }
.h-avail-opt-dot {
  width: 8px; height: 8px; border-radius: 50%; flex-shrink: 0;
}

/* Transition */
.avail-menu-enter-active, .avail-menu-leave-active { transition: opacity .15s ease, transform .15s ease; }
.avail-menu-enter-from, .avail-menu-leave-to { opacity: 0; transform: translateY(-4px); }

.h-avail-error {
  background: rgba(239,68,68,.9);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  white-space: nowrap;
  max-width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
}
.avail-err-enter-active, .avail-err-leave-active { transition: opacity .2s; }
.avail-err-enter-from, .avail-err-leave-to { opacity: 0; }
.h-avail-success {
  background: rgba(34,197,94,.9);
  color: #fff;
  font-size: 11px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 6px;
  white-space: nowrap;
}

.h-atend-badge {
  display: inline-flex;
  align-items: center;
  gap: 3px;
  font-size: 9px;
  font-weight: 700;
  color: #38bdf8;
  text-transform: uppercase;
  letter-spacing: 0.4px;
  white-space: nowrap;
  animation: atend-pulse 2s ease-in-out infinite;
}
@keyframes atend-pulse {
  0%, 100% { opacity: 1; }
  50%       { opacity: 0.6; }
}
</style>
